export const notificationListEmptyMessage = {
  description: 'Тут з’являться ваші <br/>сповіщення 🔔',
};
